import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { User, ArrowLeft, Shield } from "lucide-react";

export function ImpersonationBanner() {
  const { isImpersonating, user, originalSuperAdmin, stopImpersonating } = useAuth();

  if (!isImpersonating) {
    return null;
  }

  return (
    <>
      {/* Spacer to push content down */}
      <div className="h-12" />
      {/* Fixed banner */}
      <div 
        className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-black px-4 py-2 flex items-center justify-between shadow-lg h-12"
        data-testid="impersonation-banner"
      >
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5" />
          <span className="font-medium">
            Viewing as: <strong>{user?.name || user?.email}</strong>
            {user?.role && (
              <span className="ml-2 text-amber-900 text-sm">({user.role})</span>
            )}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-amber-800">
            Logged in as: {originalSuperAdmin?.name || originalSuperAdmin?.email}
          </span>
          <Button
            variant="secondary"
            size="sm"
            onClick={stopImpersonating}
            className="bg-black text-white hover:bg-zinc-800"
            data-testid="stop-impersonating-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Switch Back
          </Button>
        </div>
      </div>
    </>
  );
}
